<template>
    <section id="tours-block" class="tours-block" v-if="originItems.length">
        <slot name="ttl"></slot>
        <slot name="ttl1"></slot>
        <div class="row">
            <div class="col visible-md">
                <div class="tours-nav-filter">
                    <nav class="tours-nav">
                        <li>
                            <a href="#" class="tours-nav__item recommended-nav__item"
                               :class=" !cauntriesFilterProp.length && !catFilterProp.length ? 'active' : '' " @click.prevent="showAll">Всі
                                країни</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)"
                               class="tours-nav__item recommended-nav__item"
                               :class="catFilterProp.length ? 'active' : '' "
                               @click.prevent="showSpecific(specificRulesForFilter.lviv)">Тури зі Львова</a>
                        </li>
                    </nav>
                    <nav class="tours-nav">
                        <!--<li v-show="showCategory(index)">-->
                            <!--<a href="#" class="tours-nav__item"-->
                               <!--:class="cauntriesFilterProp.includes(item.id) ? 'active' : '' "-->
                               <!--@click.prevent="setCategoryFilter(item.id)">{{item.name}}</a>-->
                        <!--</li>-->
                       
                        <li v-for="(item, index) in countries" :key="10+index" v-show="showCategory(index)">
                            <a href="#" class="tours-nav__item"
                               :class="cauntriesFilterProp.includes(item.id) ? 'active' : '' "
                               @click.prevent="setCategoryFilter(item.id)">{{item.name}}</a>
                        </li>
                    </nav>
                    <a href="#" class="link-more" @click.prevent="showMore" v-show="showMoreBtn">Більше ...</a>
                </div>
            </div>
            <div class="col-lg-8 col-xl-7">
                <a :href="item.url" target="_blank" class="tours-item clearfix" v-for="(item, index) in printSpo" :key="index">
                    <div class="recommended-item__img bg-img bg-black-gradient"
                         :style="'background-image:  url('+item.image+')'">
                        <img :src="item.image" alt="">
                        <div class="recommended-item__detail">
                            <i :class="item.icon_code">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <div :class="['recommended-item__spo', 'recommended-item__spo--'+item.icon_position ]">
                            <img :src="item.icon" alt="">
                        </div>
                    </div>
                    <div class="tours-item__info">
                        <p class="tours-item__info--ttl">{{item.title}}</p>
                        <dl class="tours-item__info--list clearfix">
                            <dt v-show="item.route">Авіапереліт:</dt>
                            <dd v-show="item.route">{{item.route}}</dd>
                            <dt v-show="item.duration">Тривалість туру:</dt>
                            <dd v-show="item.duration">{{item.duration}}</dd>
                            <dt v-show="item.placing">Проживання:</dt>
                            <dd v-show="item.placing">{{item.placing}}</dd>
                            <dt v-show="item.food">Харчування:</dt>
                            <dd v-show="item.food">{{item.food}}</dd>
                        </dl>
                        <div class="tours-item__info--bottom">
                            <span class="link-more more">Більше ...</span>
                            <span class="cost">від
                                <span>{{item.price}} {{item.currency}}</span>
                            </span>
                        </div>
                    </div>
                </a>
                <div v-if="!currentItems.length" class="text-center"><h3>По вашому фільтру нічого не знайдено</h3></div>
                <pagination :pagination="pagination" :callback="loadData" :options="paginationOptions"
                            class="text-center"></pagination>
            </div>
            <div class="col-lg-4 col-xl-4 offset-xl-1">
                <div class="row tours-nav-filter hidden-md">
                    <div class="col-md-12">
                        <nav class="tours-nav">
                            <li>
                                <a href="#" class="tours-nav__item recommended-nav__item"
                                   :class=" !cauntriesFilterProp.length && !catFilterProp.length ? 'active' : '' " @click.prevent="showAll">Всі
                                    країни</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)"
                                   class="tours-nav__item recommended-nav__item"
                                   :class="catFilterProp.length ? 'active' : '' "
                                   @click.prevent="showSpecific(specificRulesForFilter.lviv)">Тури зі Львова</a>
                            </li>
                        </nav>
                        <nav class="tours-nav">
                            <li v-for="(item, index) in countries" :key="index" v-show="showCategory(index)">
                                <a href="#" class="tours-nav__item"
                                   :class="cauntriesFilterProp.includes(item.id) ? 'active' : '' "
                                   @click.prevent="setCategoryFilter(item.id)">
                                    {{item.name}}
                                </a>
                            </li>
                        </nav>
                    </div>
                    <div class="col-md-12">
                        <a href="#" class="link-more" @click.prevent="showMore" v-show="showCategoriBtn">Більше ...</a>
                    </div>
                </div>

                <slot name="managerBlock"></slot>

                <slot name="infoBlock"></slot>
            </div>
        </div>
    </section>
</template>
<script>
    import pagination from "vue-bootstrap-pagination";

    export default {
        props: ["id"],
        components: {
            pagination
        },
        data() {
            return {
                countries: [],
                showElCategory: 4,
                showMoreBtn: true,
                cauntriesFilterProp: [],
	            catFilterProp: [],
                currentItems: [],
                originItems: [],
                pagination: {
                    total: 5,
                    per_page: 5,
                    current_page: 1,
                    last_page: 0,
                    from: 0,
                    to: 8
                },
                paginationOptions: {
                    offset: 4,
                    previousText: "Prev",
                    nextText: "Next",
                    alwaysShowPrevNext: true
                },
	            specificRulesForFilter: {
                	lviv: [2,17,4]
                }
            };
        },
        computed: {
            printSpo() {
                this.pagination.last_page = Math.ceil(
                    this.currentItems.length / this.paginationOptions.offset
                );
                let curentItems = this.currentItems;

                return curentItems.slice(this.pagination.from, this.pagination.to);
            },
            showCategoriBtn() {
                return this.countries.length <= this.showElCategory + 1 ? false : true;
            }
        },
        methods: {
            showCategory(index) {
                return index > this.showElCategory ? false : true;
            },
            showMore() {
                this.showMoreBtn = false;
                this.showElCategory = this.countries.length;
            },
            setCategoryFilter(id) {
                let index = this.cauntriesFilterProp.indexOf(id);
                index >= 0
                    ? this.cauntriesFilterProp.splice(index, 1)
                    : this.cauntriesFilterProp.push(id);

                this.performCountriesFilter();
            },
            showAll() {
                this.cauntriesFilterProp = [];
	            this.catFilterProp = [];
                this.performCountriesFilter();
            },

	        showSpecific(specParam) {


            	// console.warn('LVIV');
            	this.showAll();

		        this.catFilterProp = [...specParam];
		        this.performCategoryFilter();
	        },
	        performCategoryFilter() {
		        this.pagination.current_page = 1;
		        this.pagination.to = this.pagination.per_page;
		        this.pagination.from = this.pagination.to - this.pagination.per_page;

		        var _this = this;
		        if (_this.catFilterProp.length > 0) {


			        let tmpList = _this.currentItems.filter( itm => {
                        return itm.categories.some(el => _this.catFilterProp.includes(el));
                    });

			        // this.catFilterProp.forEach(cat => {
				    //     let tmpItem = _this.currentItems.filter(function (item) {
					//         return item.categories.includes(cat);
				    //     });
                    //
				    //     tmpList = tmpList.concat(tmpItem.filter(elem => !tmpList.includes(elem)));
			        // });

			        return (_this.currentItems = tmpList);
		        }
	        },
            performCountriesFilter() {
                this.pagination.current_page = 1;
                this.pagination.to = this.paginationOptions.offset;
                this.pagination.from = this.pagination.to - this.paginationOptions.offset;

                var _this = this;
                if (_this.cauntriesFilterProp.length > 0) {
                    let tmpList = [];
	                this.catFilterProp = [];

	                this.cauntriesFilterProp.forEach(country => {
                        let tmpItem = _this.originItems.filter(function (item) {
                            // if (item.countries) {
                                return country in item.countries ? true : false;
                            // } else {
                            //     return false;
                            // }
                        });

                        tmpList = tmpList.concat(
                            tmpItem.filter(elem => !tmpList.includes(elem))
                        );
                    });

                    return (_this.currentItems = tmpList);
                } else {
                    return (_this.currentItems = _this.originItems);
                }
            },
            loadData(e) {
                this.pagination.to =
                    this.pagination.current_page * this.paginationOptions.offset;
                this.pagination.from = this.pagination.to - this.paginationOptions.offset;
            }
        },
        mounted() {
            axios.post("/spo-travel", {travelId: this.id}).then(response => {
                this.countries = response.data.countries;

                const itemsArray = Object.values(response.data.result);
                this.pagination.last_page = Math.ceil(
                    itemsArray.length / this.paginationOptions.offset
                );

                this.currentItems = itemsArray;
                this.originItems = itemsArray;
            });
            this.paginationOptions.offset = 4;
            this.pagination.to = this.paginationOptions.offset;
        },
	    // updated: function () {
		 //    this.$nextTick(function () {
			//     console.warn({countries: this.countries});
			//     console.warn({cauntriesFilterProp: this.cauntriesFilterProp});
        //
			//     console.warn({currentItems: this.currentItems});
			//     console.warn({originItems: this.originItems});
        //
			//     console.warn({catFilterProp: this.catFilterProp});
        //
			//     console.log("----------------------------------");
		 //    })
	    // }
    };
</script>
<style>
.tours-nav  + .tours-nav {
    margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TravelSpo.vue